import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import type { ConversionStatus } from '../types';

const { FiAlertCircle, FiCheckCircle, FiX } = FiIcons;

interface StatusBannerProps {
  status: ConversionStatus;
  onDismiss: () => void;
}

const StatusBanner = ({ status, onDismiss }: StatusBannerProps) => {
  if (!status?.message) return null;
  const isError = status.type === 'error';

  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      role="alert"
      aria-live="polite"
      className={`p-4 rounded-2xl flex items-center gap-3 border text-sm font-medium ${
        isError
          ? 'bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 border-red-200 dark:border-red-800'
          : 'bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-400 border-emerald-200 dark:border-emerald-800'
      }`}
    >
      <SafeIcon
        icon={isError ? FiAlertCircle : FiCheckCircle}
        className="shrink-0 text-lg"
      />
      <span className="flex-grow">{status.message}</span>
      <button
        onClick={onDismiss}
        aria-label="Dismiss notification"
        className="shrink-0 hover:opacity-70 transition-opacity p-1"
      >
        <SafeIcon icon={FiX} />
      </button>
    </motion.div>
  );
};

export default StatusBanner;
